<script>
  // import Chat from './Chat.svelte';
  import { Router, Link, Route } from "svelte-routing";
  
  let innovationInput="";
  let innovationUrlInput="";
  let innovationSourceInput="";
  const handleButton = function(){
    alert ('@handleButton save suggested innovation');
  }

  import {getContext} from 'svelte';
  const db = getContext('firebase').firestore();
  const tetradsRef=db.collection("tetrads")

  let temp=[];
  let pubTetrads=[]
  tetradsRef.where("status", "==", "published").orderBy("i")
    .get()
    .then(function(querySnapshot) {
      pubTetrads=[]
      querySnapshot.forEach(function(doc) {
          // doc.data() is never undefined for query doc snapshots
          // console.log(doc.id, " => ", doc.data());
          temp= doc.data();
          temp.id=doc.id
          pubTetrads = [...pubTetrads,temp];
      });
      //console.log("pubTetrads="+JSON.stringify(pubTetrads));
      return pubTetrads;
    })
    .catch(function(error) {
        console.log("Error getting documents: ", error);
    });

  
  let openTetrads=[];
  tetradsRef.where("status", "==", "open").orderBy("i")
    .get()
    .then(function(querySnapshot) {
      openTetrads=[]
      temp={}
      querySnapshot.forEach(function(doc) {
          // doc.data() is never undefined for query doc snapshots
          // console.log(doc.id, " => ", doc.data());
          temp= doc.data();
          temp.id=doc.id
          openTetrads = [...openTetrads,temp];
      });
      //console.log("openTetrads="+JSON.stringify(openTetrads));
      return openTetrads;
    })
    .catch(function(error) {
        console.log("Error getting documents: ", error);
    });
</script>



<div class="innovations">
  <h1>Tetrad Live!</h1>
  <h2>for <a href="http://www.mcluhansalons.ca/globalvillageday/" target="_blank" >Global Village Day 2020</a></h2>
  <p>Below are two lists of tetrads. 
  Published Tetrads show completed works. These are good examples and one way to learn about tetrads. Comments are welcomed.</p>
  <p>The Open Tetrads started without answers to any of the questions. 
  As the day progresses you will see people's interactions.
  Anyone can suggest an answer or leave a comment. All are welcomed.</p>
  <p>Note: You must sign in using your Google Account in order to leave comments or suggestions.</p>
  <p>Additional innovations with open tetrads maybe added during the day.</p>
  
  
  <h1>Innovations</h1>
  <div class="openTetrads">
    <h2>Open Tetrads</h2>
    <div>These tetrads allow public comments and interactity.</div>
    {#if openTetrads}
      <ul>
      {#each openTetrads as tetrad, index}
        <li><Link to="/tetrad/{tetrad.id}"><span class="title">{tetrad.i}</span></Link> from 
        <span class="pub">{tetrad.s}</span></li>
      {/each}
      </ul>
    {/if}

    <h2>Published Tetrads</h2>
    <div>These tetrads are published in various books, articles, web apps, etc. Comments are allowed but no interactivity.</div>
    {#if pubTetrads}
      <ul>
      {#each pubTetrads as tetrad, index}
        <li><Link to="/tetrad/{tetrad.id}"><span class="title">{tetrad.i}</span></Link> from 
        <span class="pub">{tetrad.s}</span></li>
      {/each}
      </ul>
    {/if}

  </div>


  <!-- <div class="suggestInnovatation">
    <h2>Suggest Innovation for Crowd Sourcing</h2>
    <p>You may suggest an innovation below. Approved suggestions will appear in Open Tetrads above. 
    All suggestion must include a link to the appropriate Wikipedia page.</p>
    <label for="innovationInput">Suggested Innovation: </label>
    <input bind:value={innovationInput} name="innovationInput" placeholder="Name of Innovation"  width="50">
    <label for="innovationSourceInput">Source (publication, seminar, etc.): </label>
    <label for="innovationUrlInput">Wikipedia Link to Innovation: </label>
    <input bind:value={innovationUrlInput} name="innovationUrlInput"placeholder="Link to Wikipedia"  width="50">
    <p><a href="{innovationUrlInput}" target="_blank">Check link</a></p>
    <button on:click={handleButton}>Suggest Innovation</button>
  </div> -->
</div>

<style>
  ul {list-style-type: none; margin-left: -1rem; line-height: 1.5rem;}
  li {text-emphasis: none;}
  .title {font-weight: bold;}
  .title:hover {text-decoration: underline;}
  .pub {font-style: italic}
</style>